const isDev = import.meta.env.MODE === 'development'

export const MERCHANT_IDS = {
  crumblCookie: isDev ? 1 : 8
} as const

export type MerchantKey = keyof typeof MERCHANT_IDS
